import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

const mapStateToProps = ({ me }) => {
  return {
    // ...
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    // ...
  }, dispatch)
}

export default (component) => {
  return connect(mapStateToProps, mapDispatchToProps)(component)
}
